import { render, staticRenderFns } from "./OldRegOwnerInfo.vue?vue&type=template&id=351124f6&"
import script from "./OldRegOwnerInfo.vue?vue&type=script&lang=js&"
export * from "./OldRegOwnerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports